(function () {
  if (window.__dryzeCartReservationTimer) return;
  window.__dryzeCartReservationTimer = true;

  var STORAGE_KEY = 'dryzeCartReservationEndsAt';
  var DURATION_MS = 5 * 60 * 1000;
  var VIEWERS_MIN = 2;
  var VIEWERS_MAX = 6;
  var memoryEndsAt = 0;
  var currentViewers = 3;
  var nextViewerChangeAt = 0;

  function safeGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function randomBetween(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  function scheduleNextViewerChange() {
    // Change every 3–8 seconds
    nextViewerChangeAt = Date.now() + randomBetween(3000, 8000);
  }

  function updateViewers() {
    var now = Date.now();
    if (now < nextViewerChangeAt) return currentViewers;

    var delta = Math.random() < 0.5 ? -1 : 1;
    currentViewers = Math.min(VIEWERS_MAX, Math.max(VIEWERS_MIN, currentViewers + delta));
    scheduleNextViewerChange();
    return currentViewers;
  }

  function getEndsAt() {
    var stored = parseInt(safeGet(STORAGE_KEY), 10);
    var now = Date.now();

    if (Number.isFinite(stored) && stored > now) {
      memoryEndsAt = stored;
      return stored;
    }

    if (memoryEndsAt > now) {
      return memoryEndsAt;
    }

    memoryEndsAt = now + DURATION_MS;
    safeSet(STORAGE_KEY, String(memoryEndsAt));
    return memoryEndsAt;
  }

  function formatTime(totalSeconds) {
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function syncReservationUi() {
    var endsAt = getEndsAt();
    var remainingMs = endsAt - Date.now();

    if (remainingMs <= 0) {
      memoryEndsAt = Date.now() + DURATION_MS;
      safeSet(STORAGE_KEY, String(memoryEndsAt));
      remainingMs = DURATION_MS;
    }

    var remaining = Math.ceil(remainingMs / 1000);
    var timeLabel = formatTime(remaining);
    var viewers = String(updateViewers());

    document.querySelectorAll('[data-cart-reservation-time]').forEach(function (el) {
      el.textContent = timeLabel;
    });
    document.querySelectorAll('[data-cart-reservation-viewers]').forEach(function (el) {
      el.textContent = viewers;
    });
  }

  function start() {
    currentViewers = randomBetween(VIEWERS_MIN, VIEWERS_MAX);
    scheduleNextViewerChange();
    syncReservationUi();
    setInterval(syncReservationUi, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('cart:updated', syncReservationUi);
})();
